import { jsxs as t, Fragment as b, jsx as r } from "react/jsx-runtime";
import c from "clsx";
import "js-cookie";
import "react";
import { useFieldFocus as G } from "../../hooks/useFieldFocus.js";
import { getStylesFromSelectors as J, createPureSelectors as K } from "../../utils/classNameSelectors.js";
import { ErrorIcon as O } from "../../icons/ErrorIcon.js";
import { SuccessIcon as Q } from "../../icons/SuccessIcon.js";
import { withErrorMessage as R } from "./withErrorMessage.js";
import '../../_assets/Input.DsM-GwyN.css';const T = "_input_1lr4m_44", U = "_field_1lr4m_50", X = "_inputWrapper_1lr4m_65", Y = "_textareaWrapper_1lr4m_74", Z = "_label_1lr4m_78", ee = "_disabled_1lr4m_88", se = "_error_1lr4m_99", re = "_success_1lr4m_103", le = "_iconError_1lr4m_107", ae = "_iconSuccess_1lr4m_108", me = "_helpers_1lr4m_115", te = "_textareaHelpers_1lr4m_124", ce = "_successMessage_1lr4m_129", oe = "_hint_1lr4m_135", ie = "_textarea_1lr4m_74", ne = "_withAddon_1lr4m_273", _e = "_addon_1lr4m_282", e = {
  input: T,
  field: U,
  inputWrapper: X,
  textareaWrapper: Y,
  label: Z,
  disabled: ee,
  error: se,
  success: re,
  iconError: le,
  iconSuccess: ae,
  helpers: me,
  textareaHelpers: te,
  successMessage: ce,
  hint: oe,
  "xxs-medium": "_xxs-medium_1lr4m_169",
  "xs-medium": "_xs-medium_1lr4m_178",
  "s-medium": "_s-medium_1lr4m_187",
  "ssm-medium": "_ssm-medium_1lr4m_196",
  "sm-medium": "_sm-medium_1lr4m_205",
  "m-medium": "_m-medium_1lr4m_214",
  "xm-medium": "_xm-medium_1lr4m_223",
  "l-medium": "_l-medium_1lr4m_232",
  "xl-medium": "_xl-medium_1lr4m_241",
  "xxl-medium": "_xxl-medium_1lr4m_250",
  textarea: ie,
  withAddon: ne,
  addon: _e,
  "slide-in-out": "_slide-in-out_1lr4m_1",
  "fade-in-out": "_fade-in-out_1lr4m_1"
};
function de(s) {
  return s ? /* @__PURE__ */ r("div", { className: e.hint, children: s }) : null;
}
function ue(s) {
  return `${s}`;
}
const pe = (s) => {
  const {
    ref: f,
    as: l = "input",
    className: N,
    classNameLabel: g,
    disabled: v,
    validDisabled: M,
    errorMessage: S,
    hasError: o,
    helperMessage: E,
    id: n,
    label: _,
    size: F = "medium",
    success: W,
    successMessage: d,
    maxLength: w,
    placeholder: C,
    renderAddon: a,
    type: H = "text",
    value: i,
    valueMapper: B = ue,
    onClick: I,
    render: u,
    onChange: y,
    onFocus: p,
    onBlur: x,
    classNameHelper: A,
    ...j
  } = s, z = i != null ? B(i) : void 0, m = v || M && !o, { handleFocus: D, handleBlur: L } = G(p, x, m), P = J(K(F, "small"), e), V = c(
    e.input,
    P,
    m && e.disabled,
    o && e.error,
    W && e.success,
    d && e.successMessage,
    l === "textarea" && e.textarea,
    a && e.withAddon,
    N
  ), k = c(e.label, g), $ = c(
    l === "textarea" ? e.textareaWrapper : e.inputWrapper
  ), q = c(
    l === "textarea" ? e.textareaHelpers : e.helpers,
    A
  ), h = de(o ? S : d || E);
  return /* @__PURE__ */ t(b, { children: [
    /* @__PURE__ */ t("div", { className: V ?? "", children: [
      _ && /* @__PURE__ */ r("label", { htmlFor: n, className: k, children: _ }),
      /* @__PURE__ */ r("div", { className: $, children: u ? u({
        onFocus: D,
        onBlur: L,
        classNames: e.field
      }) : /* @__PURE__ */ t(b, { children: [
        /* @__PURE__ */ r(
          l,
          {
            ...j,
            onChange: y,
            ref: f,
            className: e.field,
            id: n,
            maxLength: w,
            placeholder: C,
            value: z,
            disabled: m,
            type: H,
            onClick: I,
            onFocus: p,
            onBlur: x
          }
        ),
        a == null ? void 0 : a({
          className: e.addon,
          disabled: m
        })
      ] }) })
    ] }),
    h && /* @__PURE__ */ t("div", { className: q, children: [
      /* @__PURE__ */ r(O, { className: e.iconError }),
      /* @__PURE__ */ r(Q, { className: e.iconSuccess }),
      h
    ] })
  ] });
}, Ee = R(pe);
export {
  Ee as Input,
  pe as InputBase
};
